"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeMatrixHttpVerbAction = normalizeMatrixHttpVerbAction;
exports.pickMatrixRoleEntry = pickMatrixRoleEntry;
exports.traceRolePermissionMatrixEval = traceRolePermissionMatrixEval;
exports.rolePermissionMatrixTriStateFromTrace = rolePermissionMatrixTriStateFromTrace;
exports.evaluateRolePermissionMatrixTriState = evaluateRolePermissionMatrixTriState;
const rolePermissionsMatrixNormalize_1 = require("./rolePermissionsMatrixNormalize");
const HTTP_VERB_TO_ACTION = {
    get: "read",
    post: "create",
    put: "update",
    delete: "delete",
};
function normalizeMatrixHttpVerbAction(action) {
    var _a;
    const sanitizedAction = (0, rolePermissionsMatrixNormalize_1.sanitizeMatrixKey)(action);
    return (_a = HTTP_VERB_TO_ACTION[sanitizedAction]) !== null && _a !== void 0 ? _a : sanitizedAction;
}
function pickMatrixRoleEntry(actionNode, canonicalRole, sanitizedScopedEntity) {
    var _a;
    const roles = (_a = actionNode.roles) !== null && _a !== void 0 ? _a : {};
    if (sanitizedScopedEntity) {
        const scopedKey = `${canonicalRole}::${sanitizedScopedEntity}`;
        const scoped = roles[scopedKey];
        if (scoped) {
            return scoped;
        }
    }
    return roles[canonicalRole];
}
function traceRolePermissionMatrixEval(params) {
    const { matrix, resource, action, scopedEntity, mapHttpVerbsForAction, effectiveRole } = params;
    if (!matrix) {
        return { status: "no_matrix" };
    }
    const normalizedResource = (0, rolePermissionsMatrixNormalize_1.sanitizeMatrixKey)(resource);
    const normalizedAction = mapHttpVerbsForAction ? normalizeMatrixHttpVerbAction(action) : (0, rolePermissionsMatrixNormalize_1.sanitizeMatrixKey)(action);
    const normalizedScoped = scopedEntity ? (0, rolePermissionsMatrixNormalize_1.sanitizeMatrixKey)(scopedEntity) : null;
    const resourceNode = matrix[normalizedResource];
    if (!resourceNode) {
        return { status: "no_resource", normalizedResource };
    }
    const actionNode = resourceNode[normalizedAction];
    if (!actionNode) {
        return { status: "no_action", normalizedResource, normalizedAction };
    }
    const roleKey = (0, rolePermissionsMatrixNormalize_1.canonicalRoleKeyForMatrix)((0, rolePermissionsMatrixNormalize_1.sanitizeMatrixKey)(effectiveRole));
    const entry = pickMatrixRoleEntry(actionNode, roleKey, normalizedScoped);
    return {
        status: "resolved",
        normalizedResource,
        normalizedAction,
        normalizedScoped,
        roleKey,
        entry,
    };
}
function rolePermissionMatrixTriStateFromTrace(trace, treatMissingRoleEntryAsNull) {
    if (trace.status === "no_matrix" || trace.status === "no_resource" || trace.status === "no_action") {
        return null;
    }
    if (!trace.entry) {
        return treatMissingRoleEntryAsNull ? null : false;
    }
    return trace.entry.allowed === true;
}
function evaluateRolePermissionMatrixTriState(params) {
    return rolePermissionMatrixTriStateFromTrace(traceRolePermissionMatrixEval(params), params.treatMissingRoleEntryAsNull === true);
}
